import React, { useEffect, useState } from 'react';
import compliance from '../../images/compliance.png';
// Import the actual icon image (replace with your asset)
// import icon from '../../images/dollar.png';
import icon1 from '../../images/compl.png';
import icon2 from '../../images/compl1.png';
import icon3 from '../../images/compl2.png';
import icon4 from "../../images/compl3.png";

function ExploreLeading() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const descriptions = [
    {
image : icon1,
      title: 'Sustainable development goals',
      text: 'The Sustainable Development Goals (SDGs) are a set of 17 global goals adopted by all United Nations Member States in 2015. They provide a comprehensive framework for addressing the world’s most pressing social, economic, and environmental challenges by the year 2030. The SDGs aim to eradicate poverty, promote inclusive and sustainable economic growth, protect the planet, and ensure peace and prosperity for all.',
    },
    {
image : icon2,
      title: 'Verra',
      text: 'Verra’s VCS (Verified Carbon Standard) is a leading global standard for voluntary greenhouse gas emissions reduction projects. It provides a robust framework for the development, validation, and verification of projects that reduce greenhouse gas emissions and promote sustainable development. VCS aims to ensure the credibility and transparency of carbon offset projects by following rigorous methodologies and independent third-party verification.',
    },
    {
image : icon3,
      title: 'ISO- 50006 family',
      text: 'ISO 50006 offers practical guidance for developing energy baselines (EnB) and energy performance indicators (EnPI), which are critical for tracking and demonstrating measurable improvements. This standard ensures that organizations can effectively monitor progress against their energy objectives and quantify savings achieved through energy efficiency measures.',
    },
    {
image : icon4,
      title: 'IPCC Guidelines',
      text: 'The Intergovernmental Panel on Climate Change (IPCC) develops internationally recognized guidelines for greenhouse gas (GHG) inventories used by countries and organizations worldwide. The IPCC Guidelines provide a standardized framework for estimating, reporting, and managing emissions and removals, ensuring consistency, transparency, and comparability across jurisdictions.                                                       The guidelines support national reporting under the United Nations Framework Convention on Climate Change (UNFCCC) and form the technical foundation for credible carbon accounting systems. ',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % descriptions.length);
        setFade(true);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, [descriptions.length]);

  return (
    <section className="relative w-[1440px] h-[856px] bg-white flex flex-col items-end overflow-hidden mx-auto">
      {/* Heading */}
      <div className="w-[1200px] text-center text-[40px] font-semibold leading-[48px] -mb-48 text-[#141414] mr-10">
        Explore Leading Compliance Frameworks <span className="text-[#0D924F]">Worldwide</span>
      </div>

      {/* Group containing card and image */}
      <div className="relative w-[1137.46px] h-[520px]">
        {/* Compliance Image */}
        <img
          src={compliance}
          alt="Compliance"
          className="absolute right-[120px] top-[216px] w-[802px] rounded-lg backdrop-blur-[10.3466px] object-cover z-0"
          loading="lazy"
        />

        {/* White Card */}
        <div className="absolute -left-[100px] top-[303px] w-[441px] h-[345px] bg-white border-2 border-[#0D924F]  rounded-2xl p-6 flex flex-col gap-4 z-0">
          {/* Icon */}
          <img src={descriptions[currentIndex].image} alt="icon" className="w-[38.4px] h-[24px]" loading="lazy" />

          {/* Title */}
          <h3 className="font-medium text-[18px] text-[#141414] w-full">
            {descriptions[currentIndex].title}
          </h3>

          {/* Description with fixed height and fade */}
          <div className="w-full h-[220px] overflow-y-auto ">
            <p
              className={`font-normal text-[14px]  text-[#3B3B3B] transition-opacity duration-300 ${
                fade ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {descriptions[currentIndex].text}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExploreLeading;